import styled from 'styled-components'

import theme from 'style/theme'

export default styled.div`
  .ant-space {
    width: 100%;
  }

  .text-button {
    border-radius: 10px;
    box-shadow: 0 0 20px 0 rgba(134, 134, 134, 0.16);
    background-color: ${theme.white};
    border: 2px solid transparent;
    padding: 10px 12px;
    cursor: pointer;

    .circle {
      width: 20px;
      height: 20px;
      border-radius: 100%;
      background-color: ${theme.black};
      display: flex;
      align-items: center;
      justify-content: center;
      .ant-typography {
        color: ${theme.white};
      }
    }

    &.active {
      border-color: ${theme.primaryRed};
      .circle {
        background-color: ${theme.primaryRed};
      }
    }
  }
`
